import React, { ComponentProps } from "react";
import { Drawer } from "antd5";

import css from "./FilterDrawer.module.scss";

function FilterDrawer(props: ComponentProps<typeof Drawer>) {
  return (
    <Drawer
      title={null}
      width={460}
      closeIcon={null}
      classNames={{ body: css.drawerBody }}
      {...props}
    >
      {props.children}
    </Drawer>
  );
}

export default FilterDrawer;
